/* @flow */

import React from 'react';
import Immutable from 'immutable';
import { Segment, Message, Item } from 'semantic-ui-react';
import BlocksHeader from './BlocksHeader';
import BlockItem from './BlockItem';
import { reorderElements, enforceElementsOrder } from 'utils/ordering';

type Props = {
  mode: CatalogRenderingMode,
  templates: Array<EditorialBlockTemplate>,
  blocks: List<EditorialBlock>,
  onAdd: (type: EditorialBlockType) => void,
  onUpdate: (blocks: List<EditorialBlock>) => void,
  attached?: boolean,
  locked?: boolean,
};

const updateBlocks = blocks => updateFunction =>
  updateFunction(Immutable.Map(blocks.map(b => [b.order, b])).toList());

const mergeBlocks = (blocks, updated) =>
  updateBlocks(blocks)(map =>
    map.update(updated.order, b => ({
      ...b,
      ...updated,
    }))
  );

const removeBlock = (blocks, toDelete) =>
  updateBlocks(blocks)(map => map.remove(toDelete.order));

const EditorBlocks = ({
  mode,
  templates,
  blocks,
  onAdd,
  onUpdate,
  attached,
  locked,
}: Props) => {
  const renderContents = () => {
    if (blocks && blocks.size) {
      const updateBlock = (block: EditorialBlock) =>
        onUpdate(mergeBlocks(blocks, block));

      const reorderBlocks = (block: EditorialBlock, order: number) => {
        const reordered = reorderElements(blocks, block, order);
        onUpdate(reordered);
      };

      const deleteBlock = (block: EditorialBlock) => {
        const reordered = enforceElementsOrder(removeBlock(blocks, block));
        onUpdate(reordered);
      };

      return (
        <Item.Group divided>
          {blocks.map(b => (
            <BlockItem
              key={b.id}
              mode={mode}
              templates={templates}
              block={b}
              blocks={blocks}
              onUpdate={updateBlock}
              onOrderChanged={reorderBlocks}
              onDelete={deleteBlock}
              locked={locked}
            />
          ))}
        </Item.Group>
      );
    }

    return <Message icon="info" header="Aucun contenu éditorial" />;
  };

  return (
    <div>
      <BlocksHeader
        templates={templates}
        onAdd={onAdd}
        attached={attached}
        locked={locked}
      />
      <Segment attached={attached || 'bottom'}>
        {renderContents()}
      </Segment>
    </div>
  );
};

export default EditorBlocks;



// WEBPACK FOOTER //
// ./src/modules/edito/components/EditorBlocks.js